import PropTypes from 'prop-types';
import React from 'react';
import { useSpeakerIds } from '../../core/users/users.hooks';
// eslint-disable-next-line import/no-cycle
import Avatars from '../Avatars';

const SpeakerAvatars = ({ speakerIds, size, imageSize, ...rest }) => {
  const speakers = useSpeakerIds(speakerIds);
  if (!speakers || speakers.length === 0) return null;
  return (
    <Avatars users={speakers} size={size} imageKey="thumbnail" imageSize={imageSize} {...rest} />
  );
};

SpeakerAvatars.defaultProps = {
  imageSize: 28,
  size: undefined,
  speakerIds: undefined,
};
SpeakerAvatars.propTypes = {
  imageSize: PropTypes.number,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  speakerIds: PropTypes.arrayOf(PropTypes.string),
};

export default SpeakerAvatars;
